import { ButtonColors } from 'types';
import { useAppDispatch } from 'store';
import { Icon } from 'components/icon';
import { Button } from 'components/button';
import { markAllAsReadNotifications } from 'store/slices/notifications';

import * as Styles from './styles';
import { NotificationHeaderProps } from './types';

export const NotificationHeader = ({
  isDialog,
  unreadCount,
}: NotificationHeaderProps) => {
  const dispatch = useAppDispatch();

  if (!unreadCount) {
    return null;
  }

  return (
    <Styles.Header isDialog={isDialog}>
      {/* 1,244, not 1244 (UI sweep 18 Oct). */}
      <p>Unread Notifications: {Number(unreadCount).toLocaleString('en-US')}</p>

      <Button
        transparent={isDialog}
        disabled={!unreadCount}
        tooltip="Mark all as read"
        icon={<Icon.CheckCircle />}
        colorType={ButtonColors.LightBlue}
        padding={isDialog ? '0' : undefined}
        onClick={() => dispatch(markAllAsReadNotifications())}
      />
    </Styles.Header>
  );
};
